import ProxyBaseDAO from "./ProxyBaseDAO";
import ProxyDistanciaModel from "../../model/ProxyDistanciaModel";
import LocalizacaoModel from "../../model/LocalizacaoModel";

class ProxyDistanciaDAO extends ProxyBaseDAO {
  private static instance: ProxyDistanciaDAO;
  private endpoint = `${super.getBasePath()}`;

  private constructor() {
    super();
  }

  public static getInstance(): ProxyDistanciaDAO {
    if (!ProxyDistanciaDAO.instance) {
      ProxyDistanciaDAO.instance = new ProxyDistanciaDAO();
    }
    return ProxyDistanciaDAO.instance;
  }

  public async getDistancias(
    origem: string,
    destinos: string
  ): Promise<ProxyDistanciaModel[]> {
    return this.get(
      `REQ_PROXY_DISTANCIA_${origem}`,
      `${this.endpoint}/Location/distances?origin=${origem}&destinations=${destinos}`
    ).then((r: any) =>
      r.data.data.map((i: any) => ProxyDistanciaModel.toModel(i))
    );
  }

  public async getLocalizacao(endereco: string): Promise<LocalizacaoModel> {
    return this.get(
      `REQ_PROXY_LOCALIZACAO_${endereco}`,
      `${this.endpoint}/Location/getByAddress?address=${endereco}`
    ).then((r: any) => LocalizacaoModel.toModel(r.data.Location));
  }
}

export default ProxyDistanciaDAO;
